module.exports = __webpack_public_path__ + "static/media/photo-1566734904496-9309bb1798ae.80ec2ab2.jpeg";